export default __webpack_public_path__ + "static/media/Saibaba10.78562292.jpg";